<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="服务网点" prop="nursinghomeId">
            <el-select
              v-model="searchForm.nursinghomeId"
              style="width: 100%"
              placeholder="服务网点"
              @change="nursinghomeIdChange"
            >
              <el-option
                v-for="item in nursinghomeIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="型号名称" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="型号名称"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="设备类型" prop="deviceTypeId">
            <el-select
              v-model="searchForm.deviceTypeId"
              style="width: 100%"
              placeholder="设备类型"
            >
              <el-option
                v-for="item in deviceTypeIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="厂商" prop="manufacturer">
            <el-select
              v-model="searchForm.manufacturer"
              style="width: 100%"
              placeholder="厂商"
            >
              <el-option
                v-for="item in partnerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button v-if="permissionList.addBtn" type="primary" size="small" @click="addModelForm"> 新 增</el-button>
        <el-button v-if="permissionList.delBtn" type="danger" size="small" @click="batchDeleteFun(selectionIds)"> 删 除</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button v-if="permissionList.viewBtn" type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>
        <el-button v-if="permissionList.editBtn" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>

        <el-button v-if="permissionList.delBtn" type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button>
      </template>
    </avue-crud>
    <hr-dialog
      :title="formModel==='add'?'新增':formModel==='edit'?'编辑':'查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="ModelFormVisible"
    >
      <template slot="body">
        <ModelForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="ModelFormVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></ModelForm>
      </template>
    </hr-dialog>
  </basic-container>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { stockWarnPage, getWarehouseList, stockWarnDelete } from '../api/nursingManage.js';
import ModelForm from './modelForm.vue';
import searchFromShow from '@/components/search-form-show/index';
import { mapGetters } from 'vuex';
import { getDeviceModelPage, getDeviceTypeList, getNursinghome, getPartnerList, deviceModelRemove } from '../api/serveItemManage';

export default {
  components: { searchFromShow, ModelForm },
  data() {
    return {
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      ModelFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        projectId: '',
        warehouseId: '',
        type: '0',
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },

      projectList: [],

      option: {
        selection: true,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeId',
            dicUrl: '/api/nursing/getNursinghome',
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '型号名称',
            prop: 'name',
          },
          {
            label: '设备类型',
            prop: 'deviceTypeName',
          },
          {
            label: '厂商',
            prop: 'manufacturerName',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      deviceModelList:[],
      nursinghomeIdList:[],
      deviceTypeIdList:[],
      partnerList:[],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.deviceModel_view, false),
        addBtn: this.vaildData(this.permission.deviceModel_add, false),
        editBtn: this.vaildData(this.permission.deviceModel_edit, false),
        delBtn: this.vaildData(this.permission.deviceModel_del, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    nursinghomeIdChange(val){
      
          getDeviceTypeList({id: val}).then((res)=>{
            this.deviceTypeIdList = res.data;
          });
          
          getPartnerList({id: val}).then((res)=>{
            this.partnerList = res.data;
          });

    },
    addModelForm() {
      this.formModel = 'add';
      this.ModelFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },

    batchDeleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deviceModelRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deviceModelRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    exportFun() {
      let params = this.tool.formateObjToParamStr(this.searchForm);
      this.tool.downloadFile(
        `/api/v4ward/warehouse/stockWarn/exportStockWarmSetting?${
          this.website.tokenHeader
        }=${getToken()}&${params}`
      );
    },
    selectionChange(val) {
      this.selectionList = val;
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.selectionIds = Ids.join(',');
    },
    // 数据导出
    exportExcel(data) {
      let saveIds = data.exportExcelSelectionRadio == '1' ? '' : this.selectionIds;

      if (saveIds.length == 0 && data.exportExcelSelectionRadio == 2) {
        this.$message({
          message: '请选择需要导出的数据！',
          type: 'warning',
        });
        return;
      }
      this.$confirm('是否导出综合巡查记录数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        let projectId = this.exportForm.projectId;

        if (data.exportExcelSelectionRadio == 2) {
          this.tool.downloadFile(
            `/api/v4ward/personal/config/export/default/taskGeneralExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${
              data.configExport
            }&projectId=${projectId}&exportIds=${saveIds}`
          );
        } else {
          // 将条件参数拼接为路由传参格式
          let paramFormString = this.tool.objToform(this.exportForm);
          //
          this.tool.downloadFile(
            `/api/v4ward/personal/config/export/default/taskGeneralExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&${paramFormString}`,
            'abc.xlsx',
            'xlsx/xls'
          );
        }
      });
    },
    editRecord(row) {
      this.formModel = 'edit';
      this.formRow = row;
      this.ModelFormVisible = true;
      this.editVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    ModelForm() {
      this.formModel = 'add';
      this.ModelFormVisible = true;
    },

    recordCancle() {
      this.editVisible = false;
      this.ModelFormVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.editVisible = false;
      this.ModelFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    viewRecord(row) {
      this.formModel = 'view';
      this.formRow = row;
      this.ModelFormVisible = true;
      this.editVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        projectId: this.searchForm.projectId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    projectIdChange(projectId) {
      this.searchForm.warehouseId = '';
      this.warehouseList = [];
      getWarehouseList({ projectId: this.searchForm.projectId }).then((res) => {
        this.warehouseList = res.data;
      });
      // //  getCanteenName({projectId:projectId}).then(res=>{
      // //           this.canteenList = res.data
      // //        })
      // this.getDeptList(this.searchForm.projectId);
      // this.getCanteen(this.searchForm.projectId);
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.upWarnFlag == '') {
        this.searchForm.upWarnFlag = false;
      }
      if (this.searchForm.downWarnFlag == '') {
        this.searchForm.downWarnFlag = false;
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.type = '0';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
        if (this.nursinghomeIdList.length > 0) {
          this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
          // getWarehouseList({ projectId: this.searchForm.projectId }).then((res) => {
          //   this.warehouseList = res.data;
          // });
          getDeviceTypeList({id: this.searchForm.nursinghomeId}).then((res)=>{
            this.deviceTypeIdList = res.data;
          });
          getPartnerList({id: this.searchForm.nursinghomeId}).then((res)=>{
            this.partnerList = res.data;
          });
          this.onLoad();
        }
      });
      // getDictionary('canteen_order_status').then((res) => {
      //   this.orderStatus = res.data;
      // });
    },

    onLoad() {
      if (this.searchForm.nursinghomeId != '') {
        this.loading = true;

        getDeviceModelPage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
  
  <style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
  <style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
  